const defaults = {
        cartModal: ".js-ajax-cart-modal",
        cartModalContent: ".js-ajax-cart-modal-content",
        cartModalClose: ".js-ajax-cart-modal-close",
        cartDrawer: ".js-ajax-cart-drawer",
        cartDrawerContent: ".js-ajax-cart-drawer-content",
        cartDrawerClose: ".js-ajax-cart-drawer-close",
        cartDrawerTrigger: ".js-ajax-cart-drawer-trigger",
        cartOverlay: ".js-ajax-cart-overlay",
        cartCounter: ".js-ajax-cart-counter",
        addToCart: ".js-ajax-add-to-cart",
        removeFromCart: ".js-ajax-remove-from-cart",
        removeFromCartNoDot: "js-ajax-remove-from-cart",
        checkoutButton: ".ajax-cart-drawer__buttonsBlock",
        decreaseQuantity: ".ajax-cart-item__minus-quantity",
        increaseQuantity: ".ajax-cart-item__add-quantity",
    },
    cartModal = document.querySelector(defaults.cartModal),
    cartModalContent = document.querySelector(defaults.cartModalContent),
    cartModalClose = document.querySelector(defaults.cartModalClose),
    cartDrawer = document.querySelector(defaults.cartDrawer),
    cartDrawerContent = document.querySelector(defaults.cartDrawerContent),
    cartDrawerClose = document.querySelector(defaults.cartDrawerClose),
    cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger),
    cartOverlay = document.querySelector(defaults.cartOverlay),
    cartCounter = document.querySelector(defaults.cartCounter),
    addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart),
    decreaseQuantity = document.querySelectorAll(defaults.decreaseQuantity),
    increaseQuantity = document.querySelectorAll(defaults.increaseQuantity);
const checkoutButton = document.querySelector(defaults.checkoutButton),
    htmlSelector = document.documentElement;
for (let t = 0; t < addToCart.length; t++)
    addToCart[t].addEventListener("click", function (t) {
        t.preventDefault();
        const e = $(this).parents(".product-form").attr("id");
        $(this).parents(".product-form").find(".option-type-text.option-required input").val() ? addProductToCart(e) : $(this).parents(".product-form").find(".option-type-text.option-required input").css("border-color", "red");
    });

//////////////////////
function giftpro() {
  var vid = $('#giftpro').val()
  $.ajax({
    type:"post",
    url:"/cart/add.js",
    dataType: "json",
    data: 'quantity=' + 1 + '&id=' + vid,
    async: false
  });
}
//////////////////////

function giftpromsg() {
  var data = $('.gift_card_msg').serialize()
  $.ajax({
    type:"post",
    url:"/cart/add.js",
    dataType: "json",
    data: data,
    async: false
  });
}
//////////////
function addProductToCart(t) {
   if( $('#giftboxmsg').is(':checked') ){ 
    //   alert('yesy');
    giftpro();
  }
//   if( $('#giftboxmsg').is(':checked') ){ 
//     giftpromsg()
//   }
    $.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", async: false, data: $("#" + t).serialize(), success: addToCartOk, error: addToCartFail });
}
function multi_item__cart() {
    var t = $("#mainProduct").attr("data-pId"),
        e = $("#product_form_" + t).serialize(),
        a = $("#bundleForm").serialize();
//     if( $('#giftpro').is(':checked') ){ 
//     //   alert('yesy');
//     giftpro();
//   }
//   if( $('#giftboxmsg').is(':checked') ){ 
//     giftpromsg()
//   }
    $.ajax({
        type: "post",
        url: "/cart/add.js",
        dataType: "json",
        data: e,
//       async: false,
        success: function () {
            $.ajax({
                type: "post",
                url: "/cart/add.js",
                dataType: "json",
                data: a,
              success: function (cart) {
//                 if( $('#giftboxmsg').is(':checked') ){ 
//                   $('.primium_gift_popup').addClass('gift_open');
//                   $('body').addClass('gift_open');
//                 }
//                 else{
                if( $('#giftboxmsg').is(':checked') ){ 
                  //   alert('yesy');
                  giftpro();
                }
                  openCartDrawer(), openCartOverlay(), fetchCart();
                  $('.ajax-cart-item__info[data-id="34522108035207"]').next().hide();
//                 }
              },
            });
        },
    });
}
function fetchCart() {
    $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (t) {
            onCartUpdate(t), 0 === t.item_count ? ((cartDrawerContent.innerHTML = "Your cart is currently empty."), checkoutButton.classList.add("is-hidden")) : (renderCart(t), checkoutButton.classList.remove("is-hidden"));
       $('.ajax-cart-item__info[data-id="34522108035207"]').next().hide();
                       /////////////////////////////
          if(t.item_count == 1){
  t.items.forEach(function(item, index) {
      var free_id = item.id;
    if(free_id == 34522108035207){
    $.ajax({
    type: 'GET',
    url: '/cart/clear.js',
    dataType: 'json',
    success: function(cart) {
      cartDrawerContent.innerHTML = 'Your cart is currently empty.';
        checkoutButton.classList.add('is-hidden');
    }
    })
     }
  })
          }
/////////////////////
        },
    });
}
function removeItem(t, e) {
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + t,
        dataType: "json",
        success: function (t) {
            "function" == typeof e ? e(t) : (onCartUpdate(t), fetchCart(), removeProductFromCart());
        },
    });
}
function updateItem(t, e, a) {
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + e + "&line=" + t,
        dataType: "json",
        success: function (t) {
            "function" == typeof a ? a(t) : (onCartUpdate(t), fetchCart());
        },
    });
}
function onCartUpdate(t) {
    (cartCounter.innerHTML = t.item_count), $(".ajax-cart-drawer__subtotal").html("<label>Gesamtsumme</label><span>" + slate.Currency.formatMoney(t.total_price, theme.moneyFormat) + "</span>");
}
function addToCartOk(t) {
//     if( $('#giftboxmsg').is(':checked') ){ 
//     $('.primium_gift_popup').addClass('gift_open');
//     $('body').addClass('gift_open');
//   }
//   else{
    (cartModalContent.innerHTML = t.title + " was added to the cart!"), (cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1), openCartDrawer(), openCartOverlay(), fetchCart();
// }
}
function removeProductFromCart() {
    cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}
function addToCartFail() {
    (cartModalContent.innerHTML = "The product you are trying to add is out of stock."), openAddModal(), openCartOverlay();
}
function renderCart(t) {
  let isGiftAdded = 0;
    clearCartDrawer(),
        t.items.forEach(function (e, a) {
          let cross_cart_item_class = "";
          if(isCrossSellGiftEnabled){
            if(e.id == crossSellGiftProduct.vid){
              isGiftAdded = 1;
              cross_cart_item_class=" cart-cross-sell-item"
            }
          }
            var r = "";
            e.properties &&
                $.each(e.properties, function (t, e) {
                    e && (r += '<div class="ajax-cart-drawer__line-item ' + t + '"><span class="line-item_title">' + t + " :</span> " + e + " </div>");
                });
          var image2 = e.image;
          if(e.id == crossSellGiftProduct.vid && isCrossSellGiftEnabled){
            image2 = crossSellGiftProduct.image;
          }
          
            const o = '<div class="ajax-cart-item__imageWrap"><img class="ajax-cart-item__image" src="' + image2 + '" ></div>',
                n = '<div class="ajax-cart-item__info'+cross_cart_item_class+'" data-id="' + e.id + '" data-line="' + Number(a + 1) + '"><div class="ajax-cart-item__title">' + e.title + "</div>",
                c = '<div class="ajax-cart-item__price">' + slate.Currency.formatMoney(e.price, theme.moneyFormat) + "</div>",
                d = '<div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '">Löschen</div></div>',
                i =
                    '<div class="ajax-cart-item__quantity" data-line="' +
                    Number(a + 1) +
                    '"><span class="ajax-cart-item__minus-quantity">-</span><input type="text" class="ajax-cart-item__input-quantity" value="' +
                    e.quantity +
                    '" min="1" pattern="[0-9]*" name="qauntity[]"><span class="ajax-cart-item__add-quantity">+</span></div>',
                l = '<div class="ajax-cart-item__single" data-line="' + Number(a + 1) + '">' + o + n + c + r + d + i + "</div>";
            (cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + l), 1 == t.item_count && "bundleProduct" == e.product_type && removeItem(1);
        }),
        $(".ajax-cart-drawer__subtotal").html("<label>Gesamtsumme</label><span>" + slate.Currency.formatMoney(t.total_price, theme.moneyFormat) + "</span>"),
        (removeFromCart = document.querySelectorAll(defaults.removeFromCart)),
        (decreaseQuantity = document.querySelectorAll(defaults.decreaseQuantity)),
        (increaseQuantity = document.querySelectorAll(defaults.increaseQuantity));
    for (let e = 0; e < removeFromCart.length; e++)
        removeFromCart[e].addEventListener("click", function () {
            const e = this.parentNode.getAttribute("data-line"),
                a = this.parentNode.getAttribute("data-id");
            removeItem(e),
                setTimeout(function () {
                    removeBundle(t, a);
                }, 500);
        });
    for (let t = 0; t < decreaseQuantity.length; t++)
        decreaseQuantity[t].addEventListener("click", function () {
            updateItem(this.parentNode.getAttribute("data-line"), parseInt($(this).next("input").val()) - 1);
        });
    for (let t = 0; t < increaseQuantity.length; t++)
        increaseQuantity[t].addEventListener("click", function () {
            updateItem(this.parentNode.getAttribute("data-line"), parseInt($(this).prev("input").val()) + 1);
        });
  if(isCrossSellGiftEnabled){
    if(isGiftAdded == 0){
       if(document.querySelectorAll(".cv-0-09__wrapper").length > 0){
         document.querySelector(".cv-0-09__wrapper .cv-0-09__container").classList.remove(`cv-0-09__hide-citm`);
       }else{
          document.querySelector("html body .ajax-cart-drawer__content").insertAdjacentHTML("afterend", cartCrossSellHTML);
       }
      
    }else{
      if(document.querySelectorAll(".cv-0-09__wrapper").length > 0){
        document.querySelector(".cv-0-09__wrapper .cv-0-09__container").classList.add(`cv-0-09__hide-citm`);
      }
    }
  }
}
function removeBundle(t, e) {
    var a = e,
        r = 0;
    t.items.forEach(function (t, e) {
        "bundleProduct" == t.product_type
            ? (0,
              (r = parseInt(e) + parseInt(1)),
              $.each(t.properties, function (t, e) {
                  if (e && "_mid" == t) return e == a && removeItem(r), !1;
              }))
            : 0;
    });
}
function openCartDrawer() {
    cartDrawer.classList.add("is-open");
}
function closeCartDrawer() {
    cartDrawer.classList.remove("is-open");
}
function clearCartDrawer() {
    cartDrawerContent.innerHTML = "";
}
function openAddModal() {
    cartModal.classList.add("is-open");
}
function closeAddModal() {
    cartModal.classList.remove("is-open");
}
function openCartOverlay() {
    cartOverlay.classList.add("is-open"), htmlSelector.classList.add("is-locked");
}
function closeCartOverlay() {
    cartOverlay.classList.remove("is-open"), htmlSelector.classList.remove("is-locked");
}
// $(".product-bundle__atc").click(function () {
//     var t = $("#mainProduct").attr("data-pId"),
//         e = $(".product-bundle__selc").prop("checked"),
//         a = $(".option-type-text.option-required input").length,
//         r = $(".option-type-text.option-required input").val();
//     if (1 == e) {
//         var o = $("#bundleText").val();
//         a > 0 ? (r.length > 0 && o.length > 0 ? multi_item__cart() : $("#product-bundle__prop").css("border-color", "red")) : o.length > 0 && multi_item__cart();
//     } else a > 0 ? (r.length > 0 ? addProductToCart("product_form_" + t) : $(".product-form").find(".option-type-text.option-required input").css("border-color", "red")), : addProductToCart("product_form_" + t);
// }),
$('.product-bundle__atc').click(function(){

  var formId = $('#mainProduct').attr('data-pId');
  var bundleCheck = $('.product-bundle__selc').prop("checked") ;
  var prodOption = $('.option-type-text.option-required input').length;
//   var prodOptVal = $('.option-type-text.option-required input').val();

  var prodOptVal = [];            
  $('.option-type-text.option-required input').each(function(){
    if ($(this).val()) {
      prodOptVal.push($(this).val());
    }

  }); 
  

  
  if(bundleCheck == true){
    var bndl = $('#bundleText').val();
    if(prodOption > 0){
      if(prodOptVal.length > 0 && bndl.length > 0){
        multi_item__cart();
      }else{   
        $('#product-bundle__prop').css('border-color','red');
      }
    }else if(bndl.length > 0){
      multi_item__cart();
    }
  }     
  else if(prodOption > 0 ){
    if(prodOptVal.length > 0){
      addProductToCart('product_form_'+formId);    
    }else{
      $('.product-form').find('.option-type-text.option-required input').css('border-color','red');
       $('.product-form').find('.option-type-text.option-required .inpur_error').removeClass('hide');
      $('.product-form').find('.option-type-text.option-required input').focus();
    }
  }else{
    addProductToCart('product_form_'+formId);
  }
  
});
    cartModalClose.addEventListener("click", function () {
        closeAddModal(), closeCartOverlay();
    }),
    cartDrawerClose.addEventListener("click", function () {
        closeCartDrawer(), closeCartOverlay();
    }),
    cartOverlay.addEventListener("click", function () {
        closeAddModal(), closeCartDrawer(), closeCartOverlay();
    }),
    cartDrawerTrigger.addEventListener("click", function (t) {
        t.preventDefault(), openCartDrawer(), openCartOverlay();
    }),
    document.addEventListener("DOMContentLoaded", function () {
        fetchCart();
    });
$(document).ready(function(){
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      var cart_count = cart.item_count
      if(cart_count == 1){
        cart.items.forEach(function(item, index) {
          var free_id = item.id;
          if(free_id == 34522108035207){
            $.ajax({
              type: 'GET',
              url: '/cart/clear.js',
              dataType: 'json',
              success: function(cart) {
                location.reload();
              }
            })
          }
        })
      } 
    },
  });
})


// Gift Product Code start here/////////////////

/////////////////

$('#giftboxmsg').click(function(){
  if( $(this).is(':checked') ){ 
//     $('.primium_gift_popup').addClass('gift_open');
//     $('body').addClass('gift_open');
  }
}) 
$('.cancel_btn').click(function(){
  $('.primium_gift_popup').removeClass('gift_open');
  $('body').removeClass('gift_open');
  //   $('#giftboxmsg').prop('checked', false); // Unchecks it
  giftpro()
  openCartDrawer();
  openCartOverlay();
  fetchCart();
})


$('.validate_btn').click(function(){
  $('.primium_gift_popup').removeClass('gift_open');
  $('body').removeClass('gift_open');
  giftpromsg();
  giftpro();
  openCartDrawer();
  openCartOverlay();
  fetchCart();
})

/////////////////////////////

$('.gift_selector').change(function(){
  var data_image = $(this).find('option:selected').attr('data-image');
  $('.gift_preview_image img').attr('src',data_image);
})


$('.input_checkbox').on('change', function() {
    $('.input_checkbox').not(this).prop('checked', false);  
});

if(isCrossSellGiftEnabled){
  jQuery(document).ready(function($){
    $(document).on("click",`.${tag}__wrapper .p-submit`, function () {
        const pid = $(this).closest(`.${tag}__container`).data("id");
        $.ajax({
          type: "post",
          url: "/cart/add.js",
          dataType: "json",
          data: 'quantity=' + 1 + '&id=' + pid,
          async: false,
          success: function () {
            fetchCart();
          }
        });
    });
  });
}
// $(document).click(function (e) {
//   if (!$(e.target).closest('.input_checkbox, .primium_gift_popup').length) {
//     $('.primium_gift_popup').removeClass('gift_open');
//     $('body').removeClass('gift_open');

//   }
// });
// Gift Product code end here///////////////////